import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { editFormInput, editImageInput, getInputData } from '../../store/forms';
import { allReserveSelector, setClientData, setVehicleData } from '../../store/reserve';
import { addError } from '../../store/errors';
import { getClient, getCommuneList, getVehicle, sendCheckin1Data } from '../../api/endpoints';
import { handleApiCall } from '../../api';
import { setCommunes, getCommunes } from '../../store/models';
import useCheckin1Validation from '../../hooks/validations/useCheckin1Validation';
import CheckInStep1View from './View';
import { useLayoutParameters } from '../../hooks/useLayoutParameters';
import { componerConfiguracion } from '../../store/selectors';

dayjs.extend(customParseFormat);

function CheckInStep1() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const selectViewConfig = useMemo(makeGetViewConfig, []);
    // const viewConfig = useSelector(state => selectViewConfig(state, 'CheckInStep1'));

    const selectViewConfig = useMemo(componerConfiguracion, []);
    const viewParameters = useSelector(state => selectViewConfig(state, 'CheckInStep1'));

    const [buttonPressed, setButtonPressed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
    const view = "checkin1";
    const object = "driverData";
    const name = useSelector(getInputData(view, object, "name"));
    const phone = useSelector(getInputData(view, object, "phone"));
    const email = useSelector(getInputData(view, object, "email"));
    const adress = useSelector(getInputData(view, object, "adress"));
    const commune = useSelector(getInputData(view, object, "commune"));
    const reserveData = useSelector(allReserveSelector);
    const reservationNumber = useSelector(getInputData("login", "checkinLogin", "reservationNumber"));
    const communes = useSelector(getCommunes);
    
    const handleChangeValue = (id, value) => {
        dispatch(editFormInput({ data: value, object, input: id, view }));
    };
    const handleChange = (id, event) => {
        handleChangeValue(id, event.target.value);
    };

    const handleSuccessClientData = (input) => { 
        const client = input.data.data[0];
        const {
        tdc_cod_com,
        tdc_dir_cli,
        tmc_fec_nac,
        tmc_nom_cli,
        ttc_val_tel,
        ttc_val_eml,
        tac_ced_adl,
        tac_ced_trs,
        tac_lic_adl,
        tac_lic_trs,
        tac_ven_ced,
        tac_ven_lic
        } = client;
        dispatch(setClientData(client));
        handleChangeValue("name", tmc_nom_cli);
        handleChangeValue("phone", ttc_val_tel);
        handleChangeValue("email", ttc_val_eml);
        handleChangeValue("adress", tdc_dir_cli);
        handleChangeValue("commune", tdc_cod_com);
        dispatch(editFormInput({ 
        data: dayjs(tmc_fec_nac, "DD-MM-YYYY"), 
        object: "files", 
        input: "birthday", 
        view: "checkin2" 
        }));
        if(tac_ven_ced !== '') dispatch(editFormInput({ 
        data: dayjs(tac_ven_ced, "DD-MM-YYYY"), 
        object: "files", 
        input: "identityCardExpiration", 
        view: "checkin2" 
        }));
        if(tac_ven_lic !== '') dispatch(editFormInput({ 
        data: dayjs(tac_ven_lic, "DD-MM-YYYY"), 
        object: "files", 
        input: "driveLicenseExpiration", 
        view: "checkin2" 
        }));
        if(tac_ced_adl !== '') dispatch(editImageInput({ 
        data: tac_ced_adl, 
        object: "files", 
        input: "cedulaAdelante", 
        view: "checkin2",
        size: {
            width: 0,
            height: 0
        }, 
        source: 'core' 
        }));
        if(tac_ced_trs !== '') dispatch(editImageInput({ 
        data: tac_ced_trs, 
        object: "files", 
        input: "cedulaPosterior", 
        view: "checkin2",
        size: {
            width: 0,
            height: 0
        }, 
        source: 'core' 
        }));
        if(tac_lic_adl !== '') dispatch(editImageInput({ 
        data: tac_lic_adl, 
        object: "files", 
        input: "licenciaAdelante", 
        view: "checkin2",
        size: {
            width: 0,
            height: 0
        }, 
        source: 'core' 
        }));
        if(tac_lic_trs !== '') dispatch(editImageInput({ 
        data: tac_lic_trs, 
        object: "files", 
        input: "licenciaPosterior", 
        view: "checkin2",
        size: {
            width: 0,
            height: 0
        }, 
        source: 'core' 
        }));
     };
    const handleSuccessVehicleData = (input) => dispatch(setVehicleData(input.data.data[0]));
    const handleSuccessCommuneList = (input) => dispatch(setCommunes(input.data.data));
    const handleError = (err) => dispatch(addError(err));

    const handleSuccessCheckin1 = (input) => {
        const success = input.data.data[0].cod_sal === "0000";
        if (success) {
            const { reserve } = reserveData;
            handleApiCall(getClient, [reserve.trv_cod_cnd], handleSuccessClientData);
            navigate('/step-2');
        } else {
            setError(`Ha habido un problema con el servicio ${sendCheckin1Data}`);
            setTimeout(() => setError(''), 7000);
        }
        setLoading(false);
    };

    const isValidForm = useCheckin1Validation(true);

    const handleCheckin1 = (e) => {
        e.preventDefault();
        setButtonPressed(true);
        if (isValidForm) {
            const { client, reserve } = reserveData;
            const { trv_cod_cnd } = reserve;
            const {
                tcc_cod_ctc,
                tdc_cod_dir,
            } = client;
            const params = [
                trv_cod_cnd,
                name.data,
                tcc_cod_ctc,
                email.data,
                phone.data,
                tdc_cod_dir,
                commune.data,
                adress.data,
              ];
            handleApiCall(sendCheckin1Data, params, handleSuccessCheckin1, handleError);
            setLoading(true);
        }
    };
    
    useEffect(() => {
        const { reserve } = reserveData;
        handleApiCall(getClient, [reserve.trv_cod_cnd], handleSuccessClientData, handleError);
        handleApiCall(getVehicle, [reservationNumber.data], handleSuccessVehicleData, handleError);
        handleApiCall(getCommuneList, [0], handleSuccessCommuneList, handleError);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const mappedCommunes = communes.map((co) => ({ code: co.tmc_cod_com, text: co.tmc_des_com }));

    return (
        <CheckInStep1View
            viewParameters={viewParameters}
            
            loading={loading}
            buttonPressed={buttonPressed}
            error={error}
            
            controls={{ name, phone, email, adress, commune }}
            communes={mappedCommunes}
            
            onChange={handleChange}
            onSubmit={handleCheckin1}
        />
    );
}

export default CheckInStep1;